import styled from 'styled-components'

const Style = {
	Container: styled.div`
		display: flex;
		align-items: center;
		gap: 50px;
	`,
}

export default Style
